import React from "react";

export const Footer: React.FC = () => null
